import * as React from 'react'

import _ from 'lodash'

import Select from 'modules/core/components/Inputs/Select'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import type LeaveForm from 'modules/timeoff/lib/LeaveForm'
import Leave from 'modules/timeoff/store/models/Leave'

const getTypesLabel = (type: string) => {
  switch (type) {
    case 'accident_other':
      return i18n.t('time_off.medical_leave.type.types.accident_other')
    case 'accident_working':
      return i18n.t('time_off.medical_leave.type.types.accident_working')
    case 'lactation':
      return i18n.t('time_off.medical_leave.type.types.lactation')
    case 'maternity':
      return i18n.t('time_off.medical_leave.type.types.maternity')
    case 'paternity':
      return i18n.t('time_off.medical_leave.type.types.paternity')
    case 'sickness_common':
      return i18n.t('time_off.medical_leave.type.types.sickness_common')
    case 'sickness_professional':
      return i18n.t('time_off.medical_leave.type.types.sickness_professional')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

interface Props {
  form: LeaveForm
  leave: Leave | null | undefined
}

const MedicalLeaveTypeField = (props: Props) => {
  const { leave, form } = props
  const field = form.get('medical_leave_type')
  const label = i18n.t('time_off.medical_leave.type.label')

  if (leave && field.value) {
    const value = getTypesLabel(field.value ?? '')

    return <TextField readonly label={label} value={value} />
  }

  const options = _.keys(Leave.medicalLeaveTypes)
    .filter((type) => {
      const { lactation } = Leave.medicalLeaveTypes

      return !_.includes([lactation], type)
    })
    .map((value) => ({
      value,
      label: getTypesLabel(value ?? ''),
    }))

  return <Select label={label} field={field} options={options} none={i18n.t('common.choose')} />
}

export default MedicalLeaveTypeField
